export const SUCCESS = 'success';
export const ERROR = 'error';
export const LOADING = 'loading';
export const CLEAR = 'clear';